<template>
  <div class="kid-wrapper" :class="`theme-${profileAtCurrentDevice.theme} ${screen === 'main' ? 'mobile-align-top' : ''}`" :style="style">
    <header v-show="screen !== 'welcome'" class="kid-header">
      <div class="kid-form-holder" :class="{'no-timer': !showTimer}" v-click-outside="function() {settingsDropdownOpen = false}">
        <a
            class="dd-menu-trigger"
            href="#"
            @click.prevent="settingsDropdownOpen = !settingsDropdownOpen"
        ></a>
        <div class="account-settings-dropdown text-left" v-if="settingsDropdownOpen">
          <div class="account-settings-dropdown-item" v-if="!hasTimeRequest && profileAtCurrentDevice.todayDailyLimit !== 86400" @click="lockedReason = 'time';getMoreTime(true)">
            {{$lang.messages.kid.dropdown.ask_time}}
          </div>
          <div class="account-settings-dropdown-item account-settings-dropdown-item-muted" v-else-if="hasTimeRequest">
            {{$lang.messages.kid.dropdown.already_sent}}
          </div>
          <div class="account-settings-dropdown-item" @click="showAddLinkModal = true">
            {{$lang.messages.kid.dropdown.get_access}}
          </div>
          <div class="account-settings-dropdown-item" v-if="!isGuestProfile" @click="exitProfile">
            {{$lang.messages.kid.dropdown.switch_profile}}
          </div>
        </div>
        <div class="timer-label" v-if="showTimer">
          {{$lang.messages.kid.dropdown.title}}
        </div>
        <div class="timer" v-if="showTimer">
          {{prettyTime}}
        </div>
        <button class="btn btn-main -shadow" @click="showPassCodeScreen = true">
          {{$lang.messages.exit_kids_mode}}
        </button>
      </div>
    </header>
    <KidDecor :themeID="profileAtCurrentDevice.theme"/>
    <div v-if="screen === 'timeIsOver'" class="kid-dialog-block">
      <div class="kid-dialog flex-center">
        <DecorKidDialog/>
        <div class="kid-dialog-image">
          <img alt="screen locked" src="./../assets/img/kid/time-over.svg">
        </div>
        <div class="kid-dialog-content">
          <div class="login-pass" v-if="lockedReason === 'time'">
            {{$lang.messages.kid.time_over}}
          </div>
          <div class="login-pass" v-else>
            {{$lang.messages.kid.time_unavailable}}
          </div>
          <p v-if="isGuestProfile" class="mb-2">
            {{$lang.messages.kid.contact_parents_for_more_time}}
          </p>
          <div class="text-center">
            <button
                class="btn btn-main -shadow"
                :disabled="hasTimeRequest"
                @click="getMoreTime(lockedReason === 'time')"
            >
              {{this.hasTimeRequest ? $lang.messages.kid.kid_sent_request : $lang.messages.kid.give_more_time}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screen === 'getPermission'" class="kid-dialog-block">
      <div class="kid-dialog flex-center">
        <DecorKidDialog/>
        <div class="kid-dialog-content decor-content">
          <span class="decor-back" @click="showMainStep">
            <svg width="31" height="17" viewBox="0 0 31 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30 8.24138C17.2744 8.84123 10.1158 9.18547 2 8.24138M2 8.24138C3.4829 10.4455 5.05017 12.2102 9.11111 16M2 8.24138C3.87303 5.9917 5.57367 4.30771 9.11111 1" stroke="#8970D4" stroke-width="2" stroke-linecap="round"/>
              </svg>
            {{ $lang.messages.back }}
          </span>
          <div class="decor-title mb-2"><span class="decor-title-header"></span> H<span class="decor-title-highlight-1">e</span>y<span class="decor-title-highlight-2">!</span></div>
          <div class="mb-1">
            <input type="text" class="input decor-input" value="">
          </div>
          <div class="mb-1 decor-text text-center">
            {{$lang.messages.kid.visit_website}} <br>
            <span class="decor-text-highlight">{{$lang.messages.kid.ask_adult}}</span>
          </div>
          <div class="text-center">
            <button class="btn btn-main">{{$lang.messages.kid.get_permission}}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="screen === 'main' && profileAtCurrentDevice" class="kid-dialog-block">
      <div class="kid-dialog-avatar-wrapper" v-if="!isGuestProfile">
        <div class="kid-dialog-avatar avatar-holder m-auto mb-1">
          <img :src="profileAtCurrentDevice.avatar || $avatars[profileAtCurrentDevice.defaultAvatarId || 13]" alt="avatar">
        </div>
        <div class="locked-screen-title text-center mb-2">{{$lang.messages.hi}}, {{profileAtCurrentDevice.kidName || 'Kid'}}!</div>
      </div>
      <div v-if="profileAtCurrentDevice.allowAllLinks" class="flex-center w-100">
        <input type="search" class="form-control" :placeholder="$lang.messages.kid.google_safe_search" v-model="guestModeSearch" @keyup.enter="goToGoogle">
        <button class="btn btn-main ml-1" @click="goToGoogle">{{$lang.messages.search}}</button>
      </div>
      <div class="kid-link-list" v-if="slides">
        <VueSlickCarousel ref="carousel" class="links-carousel" :infinite=false :adaptiveHeight=false :dots=true :arrows=false>
          <div class="links-carousel-item" v-for="(slide, index) in slides" :key="index">
            <a :key="index" v-for="(link, index) in slide" :href="link.url"
               v-tooltip="{ content: link.title || link.name, classes: 'tooltip-wide' }"
               @click.prevent="onAppClick(link)" target="_blank"
               class="kid-link">
              <span class="kid-link-icon flex-center">
                <img :src="link.packageName ? 'data:image/png;base64,' + link.icon : link.icon" :alt="link.title || link.name">
              </span>
              <span class="kid-link-title text-center">{{ link.title || link.name }}</span>
            </a>
          </div>
        </VueSlickCarousel>
      </div>
      <div class="text-huge text-center w-50 m-auto" v-else>
        No links... To add a link and use them, go to <span @click="showLogin" class="link-label">Parent mode</span> and go to the Sites menu item
      </div>
    </div>
    <EnterParentPassword
        v-if="showPassCodeScreen"
        :passToCheck="passToCheck"
        @onBackClick="showPassCodeScreen = false"
        @submitSuccess="exitKidsMode(currentDeviceID)"
    />
    <EnterParentPassword
        v-if="showAddTimeUnlock"
        :passToCheck="passToCheck"
        @onBackClick="showAddTimeUnlock = false;"
        @submitSuccess="screen = 'addTimeForm'; showAddTimeUnlock = false;"
    >
      <p class="text-center mt-1 mb-1" v-if="!isGuestProfile">{{$lang.messages.kid.extra_time_request_sent}}</p>
      <p class="text-center">{{$lang.messages.kid.enter_passcode_add_more_time}}</p>
    </EnterParentPassword>
    <div v-if="screen === 'addTimeForm'" class="kid-dialog-block">
      <div class="block-popup">
        <div class="content-block-title mb-3">{{$lang.messages.kid.add_more_time}}</div>
        <div class="text-center mb-1">
          <img src="../assets/img/choose-time-image.svg" alt="choose time" class="m-auto">
        </div>
        <div class="form-group mb-3">
          <div class="form-label">{{$lang.messages.free_dashboard.one_time_session.time_limit}}</div>
          <div class="form-control-icon">
            <i class="icon-timer icon-in-input"></i>
            <v-select
                class="w-100 select-open-top"
                :label="timeLimitOptions.label"
                :placeholder="'choose time'"
                :clearable="false"
                :searchable="false"
                :appendToBody="true"
                :calculate-position="calculateDropdownPosition"
                @input="changeTimeLimit"
                :options="timeLimitOptions">
              <template slot="open-indicator">
                <svg class="vs__open-indicator" width="20" height="10" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED" stroke-width="2"/>
                </svg>
              </template>
            </v-select>
          </div>
        </div>
        <div class="text-center parent-password-buttons">
          <button @click="checkLockState" class="btn btn-outline -shadow mr-1">{{$lang.messages.cancel}}</button>
          <button @click="addActiveProfileTime" class="btn btn-main -shadow">{{$lang.messages.confirm}}</button>
        </div>
      </div>
    </div>
    <WelcomeScreens alias="kidsModeWelcome" v-if="showWelcomeScreen" @hidewelcome="showWelcomeScreen = false"/>
    <AddLinkModal
        :recommended="false"
        v-on:addlink="sentSiteRequest"
        v-on:hidemodal="showAddLinkModal = false"
        v-if="showAddLinkModal"
    />
  </div>
</template>

<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import DecorKidDialog from "@/components/DecorKidDialog"
import EnterParentPassword from "@/components/EnterParentPassword"
import router from "@/router"
import defaultThemes from "@/helpers/themes"
import {reportEvent, getSessionDuration} from "@/helpers/utils"
import {mapGetters, mapState} from 'vuex';
import KidDecor from "@/components/KidDecor";
import VueSlickCarousel from 'vue-slick-carousel'
import saveSetting from "@/components/mixins/saveSetting";
import {sessionLimitOptions} from "@/helpers/configs";
import ClickOutside from 'vue-click-outside';
import AddLinkModal from '@/components/AddLinkModal'
import WelcomeScreens from "@/components/WelcomeScreens";

const images = require.context('../assets/img/themes/', false, /\.jpg$/)

export default {
  name: 'Kid',
  mixins: [saveSetting],
  data: function () {
    return {
      isAndroid: window.Android,
      screen: 'main',
      initStep: false,
      showLoginModal: false,
      enteredPassword: null,
      errorInPassword: false,
      shouldHide: false,
      parentModeHover: false,
      lockedReason: null,
      checkedRecommendedLinks: [],
      themes: defaultThemes,
      unsubscribeFB: null,
      showPasswordBlock: false,
      passCode: '',
      showPassCodeScreen: false,
      showError: false,
      guestModeSearch: '',
      showAddTimeUnlock: false,
      showAddTimeForm: false,
      showAddLinkModal: false,
      timeLimitOptions: sessionLimitOptions,
      additionalTimeLimit: null,
      showTimer: true,
      timer: null,
      time: 0,
      timeLeft: null,
      showWelcomeScreen:!localStorage.getItem('kidsModeWelcome'),
      settingsDropdownOpen: false,
      showAddLinkPass: false,
      customLinkToAdd: null
    }
  },
  mounted () {
    this.checkLockState();
    this.runTimer();
  },

  computed: {
    ...mapGetters({
      profileAtCurrentDevice: 'profileAtCurrentDevice',
      profileIdAtCurrentDevice: 'profileIdAtCurrentDevice',
      guestProfileAtCurrentDevice: 'guestProfileAtCurrentDevice'
    }),
    ...mapState({
      user: state => state.user,
      currentDeviceID: state => state.currentDeviceID,
      settings: state => state.accountData,
    }),
    availableTime() {
      return this.profileAtCurrentDevice.availableTime;
    },
    hasTimeRequest() {
      if (this.isGuestProfile) {
        return null;
      } else {
        const currentRequests = this.settings.profiles[this.profileIdAtCurrentDevice].requests;
        return currentRequests && currentRequests.some(request => request.type === 'time');
      }
    },
    isGuestProfile() {
      return this.profileIdAtCurrentDevice === 'guestProfileAtCurrentDevice';
    },
    passToCheck() {
      return this.isGuestProfile ? this.guestProfileAtCurrentDevice.passCode : this.settings.password;
    },
    style() {
      const customTheme = this.settings.uploadedThemes &&
          this.settings.uploadedThemes.find((theme) => theme.id === this.profileAtCurrentDevice.theme)
      return customTheme ? `background: url(${customTheme.src}) bottom/cover no-repeat;` : null;
    },
    slides() {
      const linksArrayCopy = [...this.profileAtCurrentDevice.links];
      const profileLinks = this.profileAtCurrentDevice.appListings && this.isAndroid ? linksArrayCopy.concat(this.profileAtCurrentDevice.appListings) : linksArrayCopy;
      const slidesLinks = [];
      if (profileLinks) {
        while (profileLinks.length > 0) {
          let arrayPart = profileLinks.splice(0,10)
          slidesLinks.push(arrayPart)
        }
      }
      return slidesLinks
    },
    alarmTriggerTimeStamp() {
      return this.profileAtCurrentDevice.alarmTriggerTimeStamp;
    },
    prettyTime () {
      return new Date(this.time * 1000).toISOString().substr(11, 8);
    }
  },
  watch: {
    profileAtCurrentDevice() {
      this.checkLockState();
    },

    alarmTriggerTimeStamp() {
      this.runTimer();
    },
  },
  methods: {
    calculateDropdownPosition(dropdownList, component, {width, top, left}) {
        dropdownList.classList.add('dropdown-top');
        dropdownList.style.top = parseInt(top) - 40 - dropdownList.offsetHeight + 'px';
        dropdownList.style.left = left;
        dropdownList.style.width = width;
    },
    goToGoogle(){
      window.location = 'https://google.com/search?q=' + this.guestModeSearch
    },
    exitKidsMode(deviceID) {
      const sessionDuration = this.profileAtCurrentDevice.startSessionTime ? getSessionDuration(this.profileAtCurrentDevice.startSessionTime) : null;
      reportEvent('exitKidsMode', {
        isRemote: false,
        sessionDuration,
      });

      this.saveDeviceSettings(deviceID, {locked: false})
      this.switchModeDisabled = true
      setTimeout(() =>  this.switchModeDisabled = false, 1000 )
    },
    exitProfile() {
      const profileId = this.profileIdAtCurrentDevice;
      this.saveDeviceSettings(this.currentDeviceID,{
        currentProfileID: null,
      })
      this.$router.push({ path: 'locked', query: { force: '1', switch: profileId } })
    },
    changePass(value){
      this.enteredPassword = value
    },
    checkLockState(){
      // const timeUnAvailable = this.isGuestProfile ? false : isProfileTimeUnAvailable(this.profileAtCurrentDevice.availableTime);
      if (this.profileAtCurrentDevice.dailyLimitUsed >= this.profileAtCurrentDevice.todayDailyLimit || this.profileAtCurrentDevice.isUnAvailableTime) {
        this.screen = 'timeIsOver'
        this.lockedReason = this.profileAtCurrentDevice.isUnAvailableTime ? 'unavailable' : 'time'
      } else {
        this.screen = 'main'
      }
    },
    isUnAvailableTimeMethod(unavailable) {
      const today = new Date()
      const currentDate = new Date()
      const splitedTime = (timeString) => {
        return {
          min: parseInt(timeString.split(/:| /)[1]),
          hour: timeString.split(/:| /)[2] === 'PM' ? parseInt(timeString.split(/:| /)[0]) + 12 : parseInt(timeString.split(/:| /)[0]),
        }
      }
      let periodMainFrom, periodMainTo
      if (unavailable.periods) {
        periodMainFrom = currentDate.setHours(splitedTime(unavailable.periods[0].from).hour, splitedTime(unavailable.periods[0].from).min)
        periodMainTo = currentDate.setHours(splitedTime(unavailable.periods[0].to).hour, splitedTime(unavailable.periods[0].to).min)
      }

      if(unavailable.periods && unavailable.periods[1]){
        const periodAddFrom = currentDate.setHours(splitedTime(unavailable.periods[1].from).hour, splitedTime(unavailable.periods[1].from).min)
        const periodAddTo = currentDate.setHours(splitedTime(unavailable.periods[1].to).hour, splitedTime(unavailable.periods[1].to).min)
        return (today > periodMainFrom && today < periodMainTo) || (today > periodAddFrom && today < periodAddTo)
      } else {
        return (today > periodMainFrom && today < periodMainTo)
      }
    },
    getDayFromDate(stamp){
      return new Date(stamp).getDay()
    },
    imgUrl: function (path) {
      return images('./' + path)
    },
    showLogin () {
      router.push('/')
    },
    showMainStep () {
      this.settings.showWelcome = false
      this.showPas = false
      this.checkLockState()
    },
    // eslint-disable-next-line no-unused-vars
    createWindow (url) {
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=0,menubar=no,width=5000,height=5000,left=0,top=0`
      open(url, '_self', params)
    },
    getMoreTime(showAddTimeUnlock = false){
      if (!this.hasTimeRequest && !this.isGuestProfile) {
        const currentRequests = this.settings.profiles[this.profileIdAtCurrentDevice].requests;
        const newRequest = [{type: this.lockedReason}];
        this.saveProfileSettings(this.profileIdAtCurrentDevice,
            {
              requests: currentRequests ? currentRequests.concat(newRequest) : newRequest
            }
        );
        reportEvent('kidsRequest', {type: 'time'});
      }
      this.showAddTimeUnlock = showAddTimeUnlock;
    },
    onAppClick(link) {
      if (link.packageName) {
        if (this.isAndroid) {
          window.Android.onAppClick(link.packageName)
        }
      } else {
        this.createWindow(link.url)
      }
    },
    addActiveProfileTime() {
      if (this.additionalTimeLimit) {
        const currentRequests = this.profileAtCurrentDevice.requests;
        this.saveProfileSettings(this.profileIdAtCurrentDevice,
            {
              todayDailyLimit: this.profileAtCurrentDevice.todayDailyLimit + this.additionalTimeLimit,
              requests: this.isGuestProfile ? null : currentRequests.filter(request => request.type !== this.lockedReason)
            })
      }
    },
    changeTimeLimit(option) {
      this.additionalTimeLimit = option.value;
    },
    runTimer() {
      clearInterval(this.timer);
      const alarmTriggerTimeStamp = this.alarmTriggerTimeStamp;
      const secondsLeft = Math.floor((alarmTriggerTimeStamp - Date.now()) / 1000);

      if (alarmTriggerTimeStamp && secondsLeft > 0 && this.profileAtCurrentDevice.todayDailyLimit !== 86400) {
        this.time = secondsLeft;
        this.showTimer = true;
        this.timer = setInterval( () => {
          if (this.time > 0) {
            this.time--
          } else {
            clearInterval(this.timer);
          }
        }, 1000 )
      } else {
        this.showTimer = false;
      }
    },
    sentSiteRequest(link){
      this.customLinkToAdd = link;
      this.showAddLinkModal = false;
      this.$router.push('/request?redirect='+ link.url + '&dropdown=true');
    },
    addLink() {
      this.showAddLinkPass = false;
      const newLinksList = [...this.profileAtCurrentDevice.links, this.customLinkToAdd];
      this.saveProfileSettings(this.profileIdAtCurrentDevice,
          {
            links: newLinksList,
          }
      );
    }
  },
  components: {
    WelcomeScreens,
    KidDecor,
    DecorKidDialog,
    VueSlickCarousel,
    EnterParentPassword,
    AddLinkModal
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss">
@import "../assets/styles/themes";
@import "../assets/styles/kid";
</style>
